import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import {
  trackVideoPlayEvent,
  trackVideoMilestoneEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';

export const VideoSection = ({ videos }) => (
  <div className="video-section">
    <div className="video-full-width video-margin-bottom">
      <VideoPlayer
        autoPlay
        videosStoreDataKey="mainVideo"
        showControls={false}
        lightPlayIcon={
          <button className="focus-reveal-button" type="button">
            <span className="show-for-sr">play</span>
          </button>
        }
        config={{
          youtube: {
            playerVars: {
              controls: 1,
            },
            embedOptions: {
              host: 'https://www.youtube-nocookie.com',
            },
          },
        }}
        onProgress={({ url, duration, progress, videoMilestone }) =>
          trackVideoMilestoneEvent({
            url,
            duration,
            progress,
            videoMilestone,
            title: R.path(['mainVideo', 'title'], videos),
          })
        }
        onPlay={({ url, duration, progress }) =>
          trackVideoPlayEvent({
            url,
            duration,
            progress,
            title: R.path(['mainVideo', 'title'], videos),
          })
        }
      />
    </div>
  </div>
);

VideoSection.propTypes = {
  videos: PropTypes.instanceOf(PropTypes.object),
};
